import { FC } from 'react';
import { PageTitle, PageLink } from '../../../_metronic/layout/core';
import { View } from './components/View';
// import { ViewAddEdit } from './components/ViewAddEdit';
import { useParams } from 'react-router-dom';
import { decryptId } from '../../../_metronic/helpers';

const NoteContactPage: FC = () => {
  const { id_contacto, id } =
    useParams<{ id_contacto: string; id: string }>();

  const noteId = decryptId(id);
  const contactoId = decryptId(id_contacto);
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Contactos',
      path: '/clientes/contactos/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Editar',
      path: `/clientes/contactos/edit/${id_contacto}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Notas',
      path: `/clientes/contactos/edit/${id_contacto}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>
        {noteId ? 'Editar nota' : 'Nueva nota'}
      </PageTitle>

      <View
        id={noteId ? noteId : '0'}
        contactoId={contactoId ? contactoId : '0'}
      />
    </>
  );
};

export { NoteContactPage };
